import { render, staticRenderFns } from "./DailyAssignment.vue?vue&type=template&id=5391d974&"
import script from "./DailyAssignment.vue?vue&type=script&lang=js&"
export * from "./DailyAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports